import moment from "moment";
export var convertToAddOnService = function (dto) {
    return {
        id: dto.id,
        uuid: dto.uuid,
        name: dto.name,
        price: dto.price,
        taxes: dto.taxes ? dto.taxes.sort(function (a, b) { return (moment(a.created_at) > moment(b.created_at)) ? 1 : ((moment(b.created_at) > moment(a.created_at)) ? -1 : 0); }).map(function (tax) { return ({ id: tax.id, uuid: tax.uuid, name: tax.name, percentage: tax.value }); }) : [],
        active: dto.active,
        destroyable: dto.destroyable,
        olbEnabled: dto.olb_enabled,
    };
};
